export var PAGINATION = 'pagination';
//# sourceMappingURL=constants.js.map